"use strict";
exports.__esModule = true;
exports.OWNERSHIP_ORIGIN = void 0;
var OWNERSHIP_ORIGIN;
(function (OWNERSHIP_ORIGIN) {
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["DRIVER_API"] = 1] = "DRIVER_API";
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["WEB_API"] = 2] = "WEB_API";
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["SERVICES_API"] = 3] = "SERVICES_API";
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["FLOATING_INVENTORY_APP"] = 4] = "FLOATING_INVENTORY_APP";
})(OWNERSHIP_ORIGIN = exports.OWNERSHIP_ORIGIN || (exports.OWNERSHIP_ORIGIN = {}));
//# sourceMappingURL=floating_inventory.js.map